import { graphql } from '../../gql';

/**
 * The profiles list as the Shipping page shows it — the editor's own query
 * fetches a narrower set (it never displays zones), and widening that one
 * would make the profile selector pay for fields it does not render.
 */
export const SHIPPING_PROFILES_QUERY = graphql(`
  query ShippingDeliveryProfiles {
    deliveryProfiles {
      id
      name
      originCountryCode
      originPostalCode
      processingTime {
        min
        max
        unit
      }
      default {
        type
        rate
      }
      otherInternational {
        type
        rate
      }
      productCount
      zones {
        id
        countries {
          code
        }
        rate {
          type
          rate
        }
      }
    }
  }
`);
